document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.readmore');
  if (!containers.length) return;

  containers.forEach(container => {
    const p = container.querySelector('p');
    if (!p) return;
    if (p.scrollHeight <= p.clientHeight) return;

    const btn = document.createElement('span');
    btn.className = 'priv-events-read-more';
    btn.textContent = 'Leer más';

    btn.addEventListener('click', () => {
      p.classList.toggle('expanded');
      btn.textContent = p.classList.contains('expanded') ? 'Leer menos' : 'Leer más';
    });

    p.insertAdjacentElement('afterend', btn);
  });
});